import React, { Component } from "react";
import "./index.css";
import HomePage from './components/HomePage';
import FirebaseConfig from './config/FirebaseConfig';

class App extends Component {
  constructor(){
    super();
    FirebaseConfig.analytics();
  }

  render() {
    return (
      <HomePage />
    );
  }
}

export default App;
